import React, { useContext } from 'react';
import { Route } from 'react-router';
import { Switch, Redirect } from 'react-router-dom';

import {
    NavContext,
    NavRoutes,
    UserContext
} from '../contexts';

import {
    RolePage,
    UserInRolePage,
    AssignmentListPage,
    OwnerAssignmentPage,
    ReportPage,
    NotFoundPage,
    ForbiddenPage,
    NoSettingsPage,
    LogPage,
    HomePage,
    EditProjectManagersPage,
} from '../pages';

import { ApplicationRoles } from '../../helpers';
import { useIsAuthenticated } from '@azure/msal-react';

const ProtectedRoute = ({ path, ...props }) => {
    const isAuthenticated: boolean = useIsAuthenticated();
    const { userInfo, isUserInRole, isUserInRoles } = useContext(UserContext);

    const allowRoute = (path) => {
        if (!isAuthenticated)
            return false;

        if (userInfo.roles !== null && userInfo.roles.length > 0){
            if (isUserInRole(ApplicationRoles.Administrator))
                return true;

            switch (path) {
                case NavRoutes.Home:
                case NavRoutes.AllProjects:
                case NavRoutes.Logout:
                case NavRoutes.NotFound:
                case NavRoutes.Forbidden:
                case NavRoutes.NotValidAS:
                    return true;

                case NavRoutes.Admin.Dashboard:
                    return isUserInRoles([ApplicationRoles.Administrator ]);

                case NavRoutes.ManageProjectManagers:
                case NavRoutes.EditProjectManagers:
                    return isUserInRoles([ ApplicationRoles.Owner ]);

                case NavRoutes.Admin.Roles:
                case NavRoutes.Admin.EditRole:
                case NavRoutes.Admin.AddUserInRole:
                case NavRoutes.Admin.EditUserInRole:
                    return isUserInRoles([ ApplicationRoles.Administrator ]);

                //due to a bug
                case NavRoutes.MyProjectsPage:
                    return true;

                default:
                    return false;
            }

        }
        else
            return false;
    }

    const routeWithRules = (path, routeProps) => {
        if (
            isUserInRole(ApplicationRoles.Administrator) &&
            !isUserInRole(ApplicationRoles.Owner)
        ){
            switch (path) {
                case NavRoutes.ManageProjectManagers:
                case NavRoutes.EditProjectManagers:
                    return <Redirect to={NavRoutes.AllProjects} />;
                default:
                    break;
            }
        }

        if (!isUserInRoles([
            ApplicationRoles.Owner,
            ApplicationRoles.ProjectManager
        ])) {
            switch (path) {
                case NavRoutes.MyProjectsPage:
                    return <Redirect to={NavRoutes.AllProjects} />;
                default:
                    break;
            }

            return <Route {...props} />;
        }

        else
            return <Route {...props} />;
    }

    if (allowRoute(path))
        return routeWithRules(path, props);
    else
        return <Redirect to={NavRoutes.Forbidden} />;
}

export const Routes = ({ ...props }) => {
    const { menuItems } = useContext(NavContext);

    return (
        <Switch>
            {
                menuItems &&
                menuItems.map((item, index: number): JSX.Element =>
                    item.isProtected ?
                    <ProtectedRoute
                        key={index}
                        exact
                        path={item.routePath}
                        component={item.component || NotFoundPage}
                    /> :
                    <Route
                        key={index}
                        exact
                        path={item.routePath}
                        component={item.component || NotFoundPage}
                    />
                )
            }

            <ProtectedRoute exact path={NavRoutes.Home} component={HomePage} />
            <ProtectedRoute exact path={NavRoutes.Admin.EditRole} component={RolePage} />
            <ProtectedRoute exact path={NavRoutes.Admin.AddUserInRole} component={UserInRolePage} />
            <ProtectedRoute exact path={NavRoutes.Admin.EditUserInRole} component={UserInRolePage} />
            <ProtectedRoute exact path={NavRoutes.Admin.AssignmentList} component={AssignmentListPage} />
            <ProtectedRoute exact path={NavRoutes.Admin.EditOwnerAssignment} component={OwnerAssignmentPage} />
            <ProtectedRoute exact path={NavRoutes.Admin.EditReport} component={ReportPage} />
            <ProtectedRoute exact path={NavRoutes.Admin.ViewLog} component={LogPage} />
            <ProtectedRoute exact path={NavRoutes.EditProjectManagers} component={EditProjectManagersPage} />
            <Route exact path={NavRoutes.Forbidden} component={ForbiddenPage} />
            <Route component={NotFoundPage} />
        </Switch>
    );
}